import { useEffect, useState } from "react";
import api, { formatError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../ui/dialog";
import { fmtDatePR } from "../../lib/datetime";

export const CompOffDecideDialog = ({ target, onClose, onDone }) => {
  const [remarks, setRemarks] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setRemarks(""); }, [target]);
  const approve = target?.decision === "approved";
  const submit = async () => {
    if (remarks.trim().length < 3) { toast.error("Remark is mandatory (min 3 characters)"); return; }
    setBusy(true);
    try {
      await api.post(`/payroll/comp-off/${target.day.attendance_id}/decide`, { decision: target.decision, remarks: remarks.trim() });
      toast.success(approve ? "Comp-Off approved" : "Comp-Off disapproved");
      onDone?.(); onClose();
    } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!target} onOpenChange={(v) => { if (!v && !busy) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="compoff-decide-dialog">
        <DialogHeader>
          <DialogTitle>{approve ? "Approve" : "Disapprove"} Comp-Off · {fmtDatePR(target?.day?.date)}</DialogTitle>
          <DialogDescription>
            {target?.day?.comp_off_accrual || 0} day(s) · {approve ? `will be credited for ${fmtDatePR(target?.day?.date).slice(3)}` : "no comp-off will be credited"}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label>Remark <span className="text-rose-600">*</span></Label>
          <Textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} rows={3} autoFocus data-testid="compoff-decide-remarks" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button onClick={submit} disabled={busy}
            className={approve ? "bg-emerald-600 hover:bg-emerald-700 text-white" : "bg-rose-600 hover:bg-rose-700 text-white"}
            data-testid="compoff-decide-submit">
            {busy ? "Saving…" : approve ? "Approve" : "Disapprove"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
